import React from "react";
import "./ControlsDropdown.css";

const ControlsDropdown = ({
  disabled = false,
  disabledTooltip,
  label,
  options = [],
  onChange,
  value
}) => {
  return (
    <>
      <label className="control-label">
        {label}
      </label>
      <select className="control-item dropdown" onChange={onChange} value={value ?? ''} disabled={disabled} title={disabled && disabledTooltip ? disabledTooltip : undefined}>
        {options.map((opt, i) => (
          <option key={i} value={opt.value ?? opt}>
            {opt.label ?? opt}
          </option>
        ))}
      </select>
      {disabled && disabledTooltip && (
        <span className="dropdown-disabled-reason">{disabledTooltip}</span>
      )}
    </>
  );
}

export { ControlsDropdown }
